/* ============================================
   BAR & BLUE SWIM - Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Fixed header group offset --- */
  var headerGroup = document.getElementById('site-header-group');
  var mainContent = document.getElementById('main-content');

  function setPageOffset() {
    if (!headerGroup || !mainContent) return;
    var height = headerGroup.offsetHeight;
    // Always set the offset so content is never hidden behind the fixed header
    mainContent.style.paddingTop = height + 'px';
    // Also set as CSS var for use in sections (e.g. hero min-height)
    document.documentElement.style.setProperty('--header-group-height', height + 'px');
  }

  setPageOffset();
  window.addEventListener('resize', setPageOffset, { passive: true });
  window.addEventListener('load', setPageOffset, { passive: true });

  /* --- Sticky header shadow on scroll --- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Mobile drawer --- */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileDrawer = document.querySelector('.mobile-drawer');
  const drawerOverlay = document.querySelector('.mobile-drawer-overlay');
  const closeDrawerBtn = document.querySelector('.close-drawer');

  function openDrawer() {
    if (mobileDrawer) mobileDrawer.classList.add('open');
    if (drawerOverlay) drawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (mobileDrawer) mobileDrawer.classList.remove('open');
    if (drawerOverlay) drawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    // Close all submenus when drawer closes
    document.querySelectorAll('.mobile-submenu.open').forEach(function(sub) {
      sub.classList.remove('open');
    });
    document.querySelectorAll('.mobile-nav-toggle[aria-expanded="true"]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Close drawer on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('open')) {
      closeDrawer();
    }
  });

  /* --- Mobile accordion submenus --- */
  document.querySelectorAll('.mobile-nav-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var submenu = this.nextElementSibling;
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      // Close all other submenus
      document.querySelectorAll('.mobile-nav-toggle').forEach(function(otherToggle) {
        if (otherToggle !== toggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
          var otherSubmenu = otherToggle.nextElementSibling;
          if (otherSubmenu) otherSubmenu.classList.remove('open');
        }
      });

      // Toggle current submenu
      this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (submenu) submenu.classList.toggle('open', !isOpen);
    });
  });

  /* --- Scroll animations (Intersection Observer) --- */
  const fadeElements = document.querySelectorAll('.fade-in');
  if (fadeElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    fadeElements.forEach((el) => observer.observe(el));
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
